/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';

import { AppContext } from '@prisjakt/ui-app-context';
import { TextInput } from '@prisjakt/ui-inputs';
import Setting from '../setting';

class InputValueSetting extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      editingValue: this.props.value,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.cancelChange = this.cancelChange.bind(this);
    this.submitChange = this.submitChange.bind(this);
  }

  handleChange(evt) {
    this.setState({
      editingValue: evt.target.value,
    });
  }

  cancelChange() {
    this.setState({
      editingValue: this.props.value,
    });

    this.props.onStopEditing();
  }

  submitChange() {
    if (this.state.editingValue === this.props.value) {
      return;
    }
    if (this.props.value !== this.state.editingValue) {
      this.props.onChange(this.state.editingValue);
    }
  }

  handleKeyUp(evt) {
    if (evt.key === 'Enter') {
      this.submitChange();
    }
    if (evt.key === 'Escape') {
      this.cancelChange();
    }
  }

  renderEditing() {
    const { label, inputType } = this.props;

    return (
      <TextInput
        name="input-setting"
        label={label}
        type={inputType}
        value={this.state.editingValue}
        onChange={this.handleChange}
        onKeyUp={this.handleKeyUp}
        tabIndex="0"
        autoFocus
        helper={this.props.error}
        warning={Boolean(this.props.error)}
        maxLength={this.props.maxLength}
      />
    );
  }

  render() {
    const {
      label,
      value,
      editable,
      editing,
      saving,
      onStartEditing,
    } = this.props;

    return (
      <Setting
        label={label}
        value={value}
        editable={editable}
        editing={editing}
        saving={saving}
        saveButtonDisabled={this.state.editingValue === value}
        onStartEditing={() => onStartEditing()}
        onCancel={this.cancelChange}
        onSave={this.submitChange}
        render={props => this.renderEditing(props)}
      />
    );
  }
}

InputValueSetting.propTypes = {
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  onStartEditing: PropTypes.func,
  value: PropTypes.string,
  inputType: PropTypes.oneOf(['text', 'email', 'number', 'range']),
  error: PropTypes.string,
  editable: PropTypes.bool,
  editing: PropTypes.bool,
  saving: PropTypes.bool,
  label: PropTypes.string,
  onStopEditing: PropTypes.func,
  maxLength: PropTypes.number,
};

InputValueSetting.defaultProps = {
  onCancel: () => {},
  onStartEditing: () => {},
  inputType: 'text',
  value: '',
  error: undefined,
  editable: true,
  editing: false,
  saving: false,
  label: null,
  onStopEditing: () => {},
  maxLength: undefined,
};

InputValueSetting.contextType = AppContext;

export default InputValueSetting;
